export default __webpack_public_path__ + "static/media/FernandaGuarro_ponentes.d0bc553f.png";